import { ArrowForward } from '@mui/icons-material'
import { Alert, AlertTitle, Divider, Drawer, IconButton, Typography } from '@mui/material'
import { itesArLineType, sewpTrLineType } from 'src/types'
import { TR_SEWP_COLUMNS } from './sewpTypes'
import { AR_ITES_COLUMNS } from './itesTypes'
import { EditableCell } from 'src/EditQuote/steps/draft/EditableCell'
import { useMemo } from 'react'
import './BulkEdit.css'

export default function BulkEdit({
  open,
  contractNumber,
  selectedLineItems,
  setLineItems,
  drafts,
  onClose,
}: {
  open: boolean
  contractNumber: string
  selectedLineItems: (sewpTrLineType | itesArLineType)[]
  setLineItems: (ids: string[], property: string, value: string) => void
  drafts: Record<string, string | number>
  onClose: () => void
}) {
  const isSewp = contractNumber.toLowerCase() === 'nng15sd41b' || contractNumber.toLowerCase() === 'nng15sc86b'
  const isItes = contractNumber.toLowerCase() === 'w819tc25da023'
  const columns = useMemo(() => (isSewp ? TR_SEWP_COLUMNS : isItes ? AR_ITES_COLUMNS : []), [isSewp, isItes])
  const currentValue = (key: string) => {
    const values = selectedLineItems.map(item =>
      item.RequestLineId + key in drafts
        ? drafts[item.RequestLineId + key]
        : item[key as keyof (typeof selectedLineItems)[number]],
    )
    return values.length > 0 && values.every(v => v === values[0]) ? values[0] : null
  }

  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <div className="bulk-edit">
        <div className="bulk-edit-header">
          <Typography variant="h6">Bulk Edit</Typography>
          <IconButton onClick={onClose}>
            <ArrowForward />
          </IconButton>
        </div>

        <Divider />

        <div className="bulk-edit-content">
          <Alert severity="info">
            <AlertTitle>
              {selectedLineItems.length} item{selectedLineItems.length === 1 ? '' : 's'} selected for editing
            </AlertTitle>
            All {selectedLineItems.length} item{selectedLineItems.length === 1 ? '' : 's'} will be updated to reflect
            any changes made.
          </Alert>
          <div>
            {columns.map(column => {
              if (!column.editable) return null
              return (
                <div key={column.key}>
                  <Typography>{column.label}</Typography>
                  <EditableCell
                    alwaysEdit
                    canEdit
                    value={currentValue(column.key)}
                    onChange={value =>
                      setLineItems(
                        selectedLineItems.map(item => item.RequestLineId),
                        column.key,
                        column.key === 'Manufacturer' ? value.Manufacturer : value,
                      )
                    }
                    inputType={column.inputType}
                    options={column.options}
                    source={column.source}
                    contractNumber={contractNumber}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Drawer>
  )
}
